// TODO: accordion
(function (module) {
  'use strict';
  module.directive('accordionPanel', function(){
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        elem.on('click', function(e) {	
          e.preventDefault();
          var panelId =  $(this).attr('href');
		      var spanId = $(this).find('span');
          if ($(panelId).is(':visible')) {
            $(panelId).slideUp('fast');
            $(spanId).removeClass('glyphicon-chevron-down');
            $(spanId).addClass('glyphicon-chevron-right');
          } else {
            $(panelId).slideDown('fast');
			      $(spanId).removeClass('glyphicon-chevron-right');
			      $(spanId).addClass('glyphicon-chevron-down');
          }
          $('#accordion .panel-body').not(panelId).slideUp('fast');
		      $('#accordion span').not(spanId).removeClass('glyphicon-chevron-down');
		      $('#accordion span').not(spanId).addClass('glyphicon-chevron-right');
        });
      },
    };
  });
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/directives/accordionPanel.directive.js